<script setup lang="ts">
defineOptions({
  name: 'HelpersGrid',
})
</script>

<template>
  <div class="helpers-grid">
    <slot />
  </div>
</template>

<style scoped lang="scss" src="./HelpersGrid.scss" />
